import { useCallback, useEffect, useMemo, useState } from "react";
import axios from "../utils/api";

const defaultSettings = {
  support_email: "noamshvetz2009@gmail.com",
  maintenance_mode: false,
  scanner_enabled: true,
  registrations_enabled: true,
};

export function useSubscription(user) {
  const [subscription, setSubscription] = useState({ status: "loading" });
  const [account, setAccount] = useState(null);
  const [settings, setSettings] = useState(defaultSettings);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const refresh = useCallback(async () => {
    if (!user) return;
    setLoading(true);
    setError("");
    try {
      const res = await axios.get("/api/me");
      setAccount(res.data);
      setSettings(res.data.settings || defaultSettings);
      setSubscription({
        status: res.data.access?.hasAccess ? "active" : "inactive",
        source: res.data.access?.source,
        billingStatus: res.data.access?.billingStatus,
        plan: "Free",
      });
    } catch (err) {
      setError(err?.response?.data?.error || "Could not load account access.");
      setSubscription({ status: "inactive" });
    } finally {
      setLoading(false);
    }
  }, [user]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const access = account?.access || {};
  const isPro = useMemo(() => Boolean(access.hasAccess || subscription.status === "active"), [access.hasAccess, subscription.status]);
  const isAdmin = useMemo(() => Boolean(access.isAdmin || account?.user?.role === "admin"), [access.isAdmin, account]);

  return {
    subscription,
    account,
    settings,
    loading,
    error,
    isPro,
    isAdmin,
    refreshSubscription: refresh,
  };
}
